import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export const AnimationHomeInternetDelivery = () => {
  ScrollTrigger.matchMedia({
    '(min-width: 992px)': function () {
      gsap.to('.home-internet-delivery-floating-text', {
        yPercent: -50,
        ease: 'easeOut',
        scrollTrigger: {
          trigger: '.home-internet-delivery-row',
          start: '60% center',
          end: '+=450',
          scrub: 1
        }
      });
    },
    '(max-width: 991.98px)': function () {
      gsap.to('.home-internet-delivery-floating-text', {
        y: 700,
        ease: 'easeOut',
        scrollTrigger: {
          trigger: '.home-internet-delivery-features-row',
          start: 'top center',
          end: '+=1020',
          scrub: 1
        }
      });
    }
  });
};

export const AnimationHomeItSzkola = () => {
  ScrollTrigger.saveStyles('.home-it-szkola-logo, .home-it-szkola-learn-header');
  ScrollTrigger.matchMedia({
    '(min-width: 992px)': function () {
      gsap.to('.home-it-szkola-device-path-top path', {
        autoAlpha: 1,
        stagger: 0.2,
        ease: 'easeOut',
        scrollTrigger: {
          trigger: '.home-it-szkola-wrapper',
          start: '15% center',
          end: '+=450',
          scrub: 1
        }
      });

      gsap.to('.home-it-szkola-logo', {
        y: 0,
        ease: 'easeOut',
        scrollTrigger: {
          trigger: '.home-it-szkola-wrapper',
          start: '15% center',
          end: '+=400',
          scrub: 1
        }
      });

      ScrollTrigger.create({
        trigger: '.home-it-szkola-learn-container',
        start: 'top top',
        end: '+=1600',
        scrub: 1,
        pin: '.home-it-szkola-learn-wrapper'
      });

      gsap.to('.home-it-szkola-learn-background-container', {
        clipPath: `circle(27% at 14% center)`,
        webkitClipPath: `circle(27% at 14% center)`,
        scrollTrigger: {
          trigger: '.home-it-szkola-learn-container',
          start: 'top top',
          end: '+=700',
          scrub: 1,
          invalidateOnRefresh: true
        }
      });

      const reversedPaths = gsap.utils.toArray('.home-it-szkola-device-path-bottom path').reverse();
      gsap.to(reversedPaths, {
        autoAlpha: 1,
        stagger: 0.2,
        ease: 'easeOut',
        scrollTrigger: {
          trigger: '.home-it-szkola-wrapper',
          start: '15% center',
          end: '+=2300',
          scrub: 1
        }
      });

      gsap.to('.home-it-szkola-learn-header', {
        y: 0,
        autoAlpha: 1,
        scrollTrigger: {
          trigger: '.home-it-szkola-learn-container',
          start: '15% top',
          end: '+=300',
          scrub: 1
        }
      });
    },
    '(min-width: 768px) and (max-width: 991.98px)': function () {
      ScrollTrigger.create({
        trigger: '.home-it-szkola-learn-container',
        start: 'top top',
        end: '+=1600',
        scrub: 1,
        pin: '.home-it-szkola-learn-wrapper'
      });

      gsap.to('.home-it-szkola-learn-background-container', {
        clipPath: `circle(30% at 10% center)`,
        webkitClipPath: `circle(30% at 10% center)`,
        scrollTrigger: {
          trigger: '.home-it-szkola-learn-container',
          start: 'top top',
          end: '+=700',
          scrub: 1,
          invalidateOnRefresh: true
        }
      });

      gsap.to('.home-it-szkola-learn-header', {
        y: 0,
        autoAlpha: 1,
        scrollTrigger: {
          trigger: '.home-it-szkola-learn-container',
          start: '15% top',
          end: '+=300',
          scrub: 1
        }
      });
    },
    '(max-width: 767.98px)': function () {
      ScrollTrigger.create({
        trigger: '.home-it-szkola-learn-container',
        start: 'top top',
        end: '+=700',
        scrub: 1,
        pin: '.home-it-szkola-learn-wrapper'
      });

      gsap.to('.home-it-szkola-learn-background-container', {
        clipPath: `circle(38% at 15% center)`,
        webkitClipPath: `circle(38% at 15% center)`,
        scrollTrigger: {
          trigger: '.home-it-szkola-learn-container',
          start: 'top top',
          end: '+=600',
          scrub: 1,
          invalidateOnRefresh: true
        }
      });
    }
  });
};

export const AnimationHomeMleg = () => {
  ScrollTrigger.saveStyles('.home-mleg-presentation-header');
  ScrollTrigger.matchMedia({
    '(min-width: 992px)': function () {
      gsap.to('.home-mleg-path-top path', {
        autoAlpha: 1,
        stagger: 0.2,
        ease: 'easeIn',
        scrollTrigger: {
          trigger: '.home-mleg-wrapper',
          start: '-10% center',
          end: '+=2100',
          scrub: 1
        }
      });

      ScrollTrigger.create({
        trigger: '.home-mleg-presentation-container',
        start: 'top top',
        end: '+=1600',
        scrub: 1,
        pin: '.home-mleg-presentation-wrapper'
      });

      gsap.to('.home-mleg-presentation-background-container', {
        clipPath: `circle(27% at 85% center)`,
        webkitClipPath: `circle(27% at 85% center)`,
        scrollTrigger: {
          trigger: '.home-mleg-presentation-container',
          start: 'top top',
          end: '+=700',
          scrub: 1,
          invalidateOnRefresh: true
        }
      });

      const reversedPaths = gsap.utils.toArray('.home-mleg-path-bottom path').reverse();
      gsap.to(reversedPaths, {
        autoAlpha: 1,
        stagger: 0.2,
        ease: 'easeOut',
        scrollTrigger: {
          trigger: '.home-mleg-wrapper',
          start: '60% center',
          end: '+=500',
          scrub: 1
        }
      });

      gsap.to('.home-mleg-presentation-header', {
        y: 0,
        autoAlpha: 1,
        scrollTrigger: {
          trigger: '.home-mleg-presentation-container',
          start: '15% top',
          end: '+=300',
          scrub: 1
        }
      });
    },
    '(min-width: 768px) and (max-width: 991.98px)': function () {
      ScrollTrigger.create({
        trigger: '.home-mleg-presentation-container',
        start: 'top top',
        end: '+=1600',
        scrub: 1,
        pin: '.home-mleg-presentation-wrapper'
      });

      gsap.to('.home-mleg-presentation-background-container', {
        clipPath: `circle(30% at 83% 46%)`,
        webkitClipPath: `circle(30% at 83% 46%)`,
        scrollTrigger: {
          trigger: '.home-mleg-presentation-container',
          start: 'top top',
          end: '+=700',
          scrub: 1,
          invalidateOnRefresh: true
        }
      });

      gsap.to('.home-mleg-presentation-header', {
        y: 0,
        autoAlpha: 1,
        scrollTrigger: {
          trigger: '.home-mleg-presentation-container',
          start: '15% top',
          end: '+=300',
          scrub: 1
        }
      });
    },
    '(max-width: 767.98px)': function () {
      ScrollTrigger.create({
        trigger: '.home-mleg-presentation-container',
        start: 'top top',
        end: '+=700',
        scrub: 1,
        pin: '.home-mleg-presentation-wrapper'
      });

      gsap.to('.home-mleg-presentation-background-container', {
        clipPath: `circle(38% at 85% center)`,
        webkitClipPath: `circle(38% at 85% center)`,
        scrollTrigger: {
          trigger: '.home-mleg-presentation-container',
          start: 'top top',
          end: '+=600',
          scrub: 1,
          invalidateOnRefresh: true
        }
      });
    }
  });
};

export const AnimationHomeSectionHero = () => {
  ScrollTrigger.saveStyles('.home-section-hero-presentation-header');
  ScrollTrigger.matchMedia({
    '(min-width: 1400px)': function () {
      gsap.to('.home-mleg-path-top path', {
        autoAlpha: 1,
        stagger: 0.2,
        ease: 'easeIn',
        scrollTrigger: {
          trigger: '.home-section-hero',
          start: '-10% center',
          end: '+=2100',
          scrub: 1
        }
      });

      ScrollTrigger.create({
        trigger: '.home-section-hero-presentation-container',
        start: 'top top',
        end: '+=1600',
        scrub: 1,
        pin: '.home-section-hero-presentation-wrapper'
      });

      gsap.to('.home-section-hero-presentation-background-container', {
        clipPath: `circle(27% at 89% center)`,
        webkitClipPath: `circle(27% at 89% center)`,
        scrollTrigger: {
          trigger: '.home-section-hero-presentation-container',
          start: '20% top',
          end: '+=700',
          scrub: 1,
          invalidateOnRefresh: true
        }
      });

      const reversedPaths = gsap.utils.toArray('.home-section-hero-path-bottom path').reverse();
      gsap.to(reversedPaths, {
        autoAlpha: 1,
        stagger: 0.2,
        ease: 'easeOut',
        scrollTrigger: {
          trigger: '.home-section-hero',
          start: '60% center',
          end: '+=500',
          scrub: 1
        }
      });

      gsap.to('.home-section-hero-presentation-header', {
        y: 0,
        autoAlpha: 1,
        scrollTrigger: {
          trigger: '.home-section-hero-presentation-container',
          start: '50% 50%',
          end: '+=300',
          scrub: 1
        }
      });
    },
    '(min-width: 1200px) and (max-width: 1399.98px)': function () {
      gsap.to('.home-mleg-path-top path', {
        autoAlpha: 1,
        stagger: 0.2,
        ease: 'easeIn',
        scrollTrigger: {
          trigger: '.home-section-hero',
          start: '-10% center',
          end: '+=2100',
          scrub: 1
        }
      });

      ScrollTrigger.create({
        trigger: '.home-section-hero-presentation-container',
        start: 'top top',
        end: '+=1600',
        scrub: 1,
        pin: '.home-section-hero-presentation-wrapper'
      });

      gsap.to('.home-section-hero-presentation-background-container', {
        clipPath: `circle(27% at 86% center)`,
        webkitClipPath: `circle(27% at 86% center)`,
        scrollTrigger: {
          trigger: '.home-section-hero-presentation-container',
          start: '20% top',
          end: '+=700',
          scrub: 1,
          invalidateOnRefresh: true
        }
      });

      const reversedPaths = gsap.utils.toArray('.home-section-hero-path-bottom path').reverse();
      gsap.to(reversedPaths, {
        autoAlpha: 1,
        stagger: 0.2,
        ease: 'easeOut',
        scrollTrigger: {
          trigger: '.home-section-hero',
          start: '60% center',
          end: '+=500',
          scrub: 1
        }
      });

      gsap.to('.home-section-hero-presentation-header', {
        y: 0,
        autoAlpha: 1,
        scrollTrigger: {
          trigger: '.home-section-hero-presentation-container',
          start: '50% 50%',
          end: '+=300',
          scrub: 1
        }
      });
    },
    '(min-width: 992px) and (max-width: 1199.98px)': function () {
      gsap.to('.home-mleg-path-top path', {
        autoAlpha: 1,
        stagger: 0.2,
        ease: 'easeIn',
        scrollTrigger: {
          trigger: '.home-section-hero',
          start: '-10% center',
          end: '+=2100',
          scrub: 1
        }
      });

      ScrollTrigger.create({
        trigger: '.home-section-hero-presentation-container',
        start: 'top top',
        end: '+=1600',
        scrub: 1,
        pin: '.home-section-hero-presentation-wrapper'
      });

      gsap.to('.home-section-hero-presentation-background-container', {
        clipPath: `circle(27% at 85% center)`,
        webkitClipPath: `circle(27% at 85% center)`,
        scrollTrigger: {
          trigger: '.home-section-hero-presentation-container',
          start: '20% top',
          end: '+=700',
          scrub: 1,
          invalidateOnRefresh: true
        }
      });

      const reversedPaths = gsap.utils.toArray('.home-section-hero-path-bottom path').reverse();
      gsap.to(reversedPaths, {
        autoAlpha: 1,
        stagger: 0.2,
        ease: 'easeOut',
        scrollTrigger: {
          trigger: '.home-section-hero',
          start: '60% center',
          end: '+=500',
          scrub: 1
        }
      });

      gsap.to('.home-section-hero-presentation-header', {
        y: 0,
        autoAlpha: 1,
        scrollTrigger: {
          trigger: '.home-section-hero-presentation-container',
          start: '50% 50%',
          end: '+=300',
          scrub: 1
        }
      });
    },
    '(min-width: 768px) and (max-width: 991.98px)': function () {
      ScrollTrigger.create({
        trigger: '.home-section-hero-presentation-container',
        start: 'top top',
        end: '+=1600',
        scrub: 1,
        pin: '.home-section-hero-presentation-wrapper'
      });

      gsap.to('.home-section-hero-presentation-background-container', {
        clipPath: `circle(30% at 83% 50%)`,
        webkitClipPath: `circle(30% at 83% 50%)`,
        scrollTrigger: {
          trigger: '.home-section-hero-presentation-container',
          start: '20% top',
          end: '+=700',
          scrub: 1,
          invalidateOnRefresh: true
        }
      });

      gsap.to('.home-section-hero-presentation-header', {
        y: 0,
        autoAlpha: 1,
        scrollTrigger: {
          trigger: '.home-section-hero-presentation-container',
          start: '50% 50%',
          end: '+=300',
          scrub: 1
        }
      });
    },
    '(max-width: 767.98px)': function () {
      ScrollTrigger.create({
        trigger: '.home-section-hero-presentation-container',
        start: 'top top',
        end: '+=700',
        scrub: 1,
        pin: '.home-section-hero-presentation-wrapper'
      });

      gsap.to('.home-section-hero-presentation-background-container', {
        clipPath: `circle(40% at 80% center)`,
        webkitClipPath: `circle(40% at 80% center)`,
        scrollTrigger: {
          trigger: '.home-section-hero-presentation-container',
          start: 'top top',
          end: '+=600',
          scrub: 1,
          invalidateOnRefresh: true
        }
      });
    }
  });
};
